import React from 'react';

import { Shimmer } from '~/ui/components';
import { Clock, DownloadFile, Replay, Sms, Warning } from '~/ui/assets/icons';
import { ContractView } from '../../ContractTab';
import {
  Grid,
  GridContainer,
  GridTitle,
  Tile,
  TileIcon,
  TileTitle,
  TileTop,
} from '../ContractTilesGrid/ContractTilesGrid.styled';

type TileConfig = {
  key: ContractView;
  title: string;
  icon: React.ReactNode;
};

const CARD_TILES: TileConfig[] = [
  { key: 'card-other-info', title: 'Outras informações', icon: <Sms /> },
  { key: 'card-files', title: 'Arquivos', icon: <DownloadFile /> },
  { key: 'card-history', title: 'Histórico', icon: <Clock /> },
  { key: 'card-pendencies', title: 'Pendências', icon: <Warning /> },
  { key: 'card-returns', title: 'Retornos', icon: <Replay /> },
];

export type CardContractTilesGridProps = {
  loading?: boolean;
  onNavigate: (view: ContractView) => void;
};

export function CardContractTilesGrid({ loading, onNavigate }: CardContractTilesGridProps) {
  return (
    <GridContainer>
      <GridTitle>Mais detalhes do contrato</GridTitle>
      <Grid>
        {CARD_TILES.map((tile) => (
          <Tile key={tile.key} $disabled={loading} onClick={!loading ? () => onNavigate(tile.key) : undefined}>
            {loading ? (
              <>
                <TileTop>
                  <Shimmer height={16} width={80} br={4} />
                  <Shimmer height={24} width={24} br={4} />
                </TileTop>
                <Shimmer height={14} width={100} br={4} />
              </>
            ) : (
              <TileTop>
                <TileTitle>{tile.title}</TileTitle>
                <TileIcon>{tile.icon}</TileIcon>
              </TileTop>
            )}
          </Tile>
        ))}
      </Grid>
    </GridContainer>
  );
}
